import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-icon_558f3db832f825dad78bcbb78b3c6668",
  "use": "plus-icon_558f3db832f825dad78bcbb78b3c6668-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-icon_558f3db832f825dad78bcbb78b3c6668\">\n<path d=\"M8 1C8 0.447715 7.55229 0 7 0C6.44772 0 6 0.447715 6 1V6H1C0.447715 6 0 6.44772 0 7C0 7.55229 0.447715 8 1 8H6V13C6 13.5523 6.44772 14 7 14C7.55229 14 8 13.5523 8 13V8H13C13.5523 8 14 7.55229 14 7C14 6.44772 13.5523 6 13 6H8V1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol